import React, { useEffect, FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  clearHealthCareSchemesDoctorsUsersLoginDetailsUrlRequiredDocs,
  clearPageToHealthCareIdMap,
  clearSelectedHealthCare,
  clearSelectedHealthCareScheme,
  setHealthCareFilters,
} from "../../models/healthCareSlice";
import { AppDispatch, RootState } from "../../store/store";
import HealthCareList from "../../components/health-care/HealthCareList";
import TitleWithNavBack from "../../components/title-with-nav-back/TitleWithNavBack";
import { Button, Col, Row } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import {
  LIST_DEFAULT_PAGE_SIZE,
  LIST_ORDER,
  ROUTES,
} from "../../utils/constants";
import { IHealthCareFilter } from "../../interfaces/IHealthCare";
import { formatDate, getDateMonthsAgo } from "../../utils/globalUtils";
import Filters from "../../components/filters/Filters";
import dayjs from "dayjs";
import { getHealthCares } from "../../utils/healthCareSliceFunc";

const HealthCareListContainer: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { healthCares, auth } = useSelector((state: RootState) => state);

  const styles = {
    healthCareHeading: {
      display: "flex",
      justifyContent: "space-between",
    },
  };

  useEffect(() => {
    if (auth.serverTime) {
      const currDate = dayjs(auth.serverTime).format("DD-MM-YYYY");
      const startDate = dayjs(auth.serverTime)
        .subtract(1, "month")
        .format("DD-MM-YYYY");
      const initialHealthCareFilters: IHealthCareFilter = {
        searchTerm: "",
        orderBy: LIST_ORDER.DESC,
        pageNumber: 1,
        pageSize: LIST_DEFAULT_PAGE_SIZE,
        startDate: null,
        endDate: null,
      };
      dispatch(setHealthCareFilters(initialHealthCareFilters));
      dispatch(
        getHealthCares({
          filters: initialHealthCareFilters,
        })
      );
    }
  }, []);

  const handlePageChange = (pageNumber: number) => {
    dispatch(
      setHealthCareFilters({
        ...healthCares.healthCareFilters,
        pageNumber: pageNumber,
      })
    );
    if (!(pageNumber in healthCares.pageToHealthCareIdMap)) {
      dispatch(
        getHealthCares({
          filters: { ...healthCares.healthCareFilters, pageNumber: pageNumber },
        })
      );
    }
  };

  const handleFiltersChange = (newFilters: IHealthCareFilter) => {
    const filters = {
      ...newFilters,
      pageNumber: 1,
      pageSize: 100,
    };
    dispatch(clearPageToHealthCareIdMap());
    dispatch(setHealthCareFilters(filters));
    dispatch(
      getHealthCares({
        filters: filters,
      })
    );
  };

  const handleNavigate = (string: any) => {
    navigate(string);
  };

  return (
    <>
      <TitleWithNavBack title="HEALTH CARE LIST" />
      <Row style={styles.healthCareHeading}>
        <Filters
          searchPlaceholder="SEARCH BY HEALTH CARE NAME"
          handleFiltersChange={handleFiltersChange}
          filters={healthCares.healthCareFilters}
        />
        <Col>
          <Button
            type="primary"
            icon={<PlusCircleOutlined />}
            onClick={() => {
              dispatch(clearSelectedHealthCare());
              dispatch(
                clearHealthCareSchemesDoctorsUsersLoginDetailsUrlRequiredDocs()
              );
              navigate({ pathname: ROUTES.ADD_HEALTHCARE });
            }}
          >
            NEW HEALTH CARE
          </Button>
        </Col>
      </Row>
      <HealthCareList
        currentPage={healthCares.healthCareFilters.pageNumber}
        totalHealthCares={healthCares.totalAvailableHealthCares}
        allHealthCares={healthCares.healthCares}
        isFetchingAllHealthCares={healthCares.isFetchingAllHealthCares}
        healthCareIds={
          healthCares.pageToHealthCareIdMap[
            healthCares.healthCareFilters.pageNumber
          ]
        }
        handlePageChange={handlePageChange}
        handleNavigate={handleNavigate}
      />
    </>
  );
};

export default HealthCareListContainer;
